import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {LoaderClass} from "./LoaderClass"
import {UploadAvatarClass} from "../components/UploadAvatarClass"
import {getAuthHeader, objectLang, setErrorWindow, setPathBack} from "../functions"
import {ModalWin} from "./ModalWin"

export const UploadAvatar = () => {
    const {request, loading} = useHttp()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [avatars, setAvatars] = useState([])

    const auth = useContext(AuthContext)
    const lang = objectLang().language
    const l = lang.lang

    setPathBack(`/${l}/upload-avatar`)

    const fetch = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/cloudinary/get-avatars`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow())
            }

            setAvatars(data['avatars'])

        } catch (e) {
            window.location.replace(`/${l}/profile`)
        }
    }, [request, auth])

    useEffect(() => {
        fetch().then()
    }, [fetch])

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            <UploadAvatarClass
                lang={lang}
                avatars={avatars}
                avatarLink={auth.avatarLink}
            />
        </>
    )
}